define.alias("shared/components/shared/post/secondary/activity/divider", "media/components/shared/post/secondary/activity/divider");